export var config = {
  background: '#1e1e1e',
  foreground: '#c5c8c6',
  selection: '#4747a1',
  selectionMatch: '#4747a1',
  cursor: '#c07020',
  dropdownBackground: '#525252',
  activeLine: '#30303078',
  matchingBracket: '#303030',
  keyword: '#676867',
  storage: '#676867',
  variable: '#c7444a',
  parameter: '#6089B4',
  function: '#9872A2',
  string: '#D08442',
  constant: '#8080FF',
  type: '#9B0000',
  class: '#CE6700',
  number: '#6089B4',
  comment: '#9A9B99',
  heading: '#D0B344',
  invalid: '#FF0B00',
  regexp: '#D08442',
  tag: '#6089B4'
};